/* gk-product.js - Custom JavaScript for product page functionality
 * This file contains custom behavior modifications for the product page
 */

// Run the script on every product page when the DOM is loaded

document.addEventListener('DOMContentLoaded', function() {
  // Set up a MutationObserver to watch for dynamic addition of the tiered prices table
  const observer = new MutationObserver((mutations, obs) => {
    const tables = document.querySelectorAll('.tpo_option-tiered-prices-table');
    if (tables.length > 0) {
      tables.forEach(table => {
        const hintElement = document.getElementById('gk-quantity-discount-hint');
        if (hintElement && (!table.nextElementSibling || !table.nextElementSibling.classList.contains('gk-quantity-discount-hint'))) {
          // Clone the hint element since we might need it multiple times
          const notice = hintElement.cloneNode(true);
          notice.style.display = 'block'; // Make it visible
          table.parentNode.insertBefore(notice, table.nextSibling);
          console.log('Notice inserted for table:', table);
        }
      });
      // Disconnect observer once the target elements have been found and processed
      obs.disconnect();

      // --- Neue Funktionalität: Tabelleninhalt bearbeiten ---
      // Hinweis: Damit auf Übersetzungen zugegriffen werden kann, muss diese Datei als .js.liquid verarbeitet werden
      var localizedFrom = ">=";
      
      tables.forEach(table => {
        var rows = table.querySelectorAll('tr');
        rows.forEach(row => {
          // Process first column: nur 'From' entfernen
          if (row.cells.length >= 1) {
            var cell0 = row.cells[0];
            var text0 = cell0.textContent;
            text0 = text0.replace(/\bFrom\b/, ">=").trim();
            cell0.textContent = text0;
          }
          // Process second column: remove 'Ersparnis' and perform replacements
          if (row.cells.length >= 2) {
            var cell1 = row.cells[1];
            var text1 = cell1.textContent;
            text1 = text1.replace(/Ersparnis\s*/i, "").trim();
            text1 = text1.replace(/^([0-9]+)\s*-\s*\1$/, "$1");
            var match = text1.match(/((?:€\s*)?\d+(?:,\d+)?(?:\s*[€%])?)/);
            if(match) {
              cell1.textContent = match[1].trim();
            }
          }
        });
      });
      // --- Ende neue Funktionalität ---
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  console.log('MutationObserver started.');

  // Sync desktop and mobile price containers when variant changes
  var desktopPrice = document.querySelector("div[id^='price-']:not([id$='-mobile'])");
  if (desktopPrice) {
    var mobilePriceId = desktopPrice.id + "-mobile";
    var mobilePrice = document.getElementById(mobilePriceId);
    if (mobilePrice) {
      const priceSyncObserver = new MutationObserver(function(mutationsList, observer) {
        mobilePrice.innerHTML = desktopPrice.innerHTML;
      });
      priceSyncObserver.observe(desktopPrice, { childList: true, subtree: true });
      console.log('Price sync observer established on', desktopPrice.id, mobilePriceId);
    }
  }
}); 